<div class="panel-flat-color secondary-panel" data-qa="quick-links-panel">
    <div class="panel-flat-header">
        <h3>Quick Links</h3>
    </div>
    <div class="panel-flat-body large position-relative">
        @if (!company()) {
            <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
        }
        <div>
            <h4 class="fw-bold">New Pages</h4>
            <ul>
                <li>
                    <a
                        [sref]="{ target: 'companyClientServices', options: { companyId: company().companyID } }"
                        anchor-route
                        data-qa="quick-links-client-services"
                    >
                        Client Services
                    </a>
                </li>
                <li>
                    <a
                        [sref]="{ target: 'companySettings', options: { companyId: company().companyID } }"
                        anchor-route
                        data-qa="quick-links-company-settings"
                    >
                        Company Settings
                    </a>
                </li>
                @if (hasPrivateItemsPermission) {
                    <li>
                        <a
                            [sref]="{ target: 'companyContractTerms', options: { companyId: company().companyID } }"
                            anchor-route
                            data-qa="quick-links-contract-terms"
                        >
                            Contract Terms
                        </a>
                    </li>
                }
                @if (isTopLevelCompany()) {
                    <li>
                        <a
                            [sref]="{
                                target: 'propertyCharacteristicsOverrides',
                                options: { companyId: company().companyID },
                            }"
                            anchor-route
                            data-qa="quick-links-property-characteristics-overrides"
                        >
                            Company Property Characteristics Overrides
                        </a>
                    </li>
                }
                @if (hasPrivateItemsPermission) {
                    <li>
                        <a
                            [sref]="{ target: 'companyInvoices', options: { companyId: company().companyID } }"
                            anchor-route
                            data-qa="quick-links-invoices"
                        >
                            Invoices
                        </a>
                    </li>
                }
            </ul>
        </div>
        @if (company() && showComplianceInfo()) {
            <div>
                <h4 class="fw-bold">Compliance Info</h4>
                <ul>
                    <li>
                        <a
                            [sref]="{
                                target: 'supplementalInformationSheet',
                                options: { companyId: company().companyID },
                            }"
                            anchor-route
                            data-qa="quick-links-supplemental-information"
                        >
                            Supplemental Information
                        </a>
                    </li>
                    <li>
                        <a
                            [sref]="{
                                target: 'companyReturnSettings',
                                options: {
                                    companyId: company().companyID,
                                },
                            }"
                            anchor-route
                            data-qa="quick-links-compliance-company-return-settings"
                        >
                            Return Settings
                        </a>
                    </li>
                    <li>
                        <a
                            [sref]="{
                                target: 'assetList',
                                options: {
                                    companyId: isTopLevelCompany() ? company().companyID : company().topLevelCompanyId,
                                },
                            }"
                            anchor-route
                            data-qa="quick-links-compliance-assets"
                        >
                            Assets
                            @if (!isTopLevelCompany()) {
                                <span>({{ parentCompany().companyName }} and its subsidiary companies)</span>
                            }
                        </a>
                    </li>
                    <li>
                        <a
                            [sref]="{
                                target: 'filingBatchList',
                                options: {
                                    companyId: isTopLevelCompany() ? company().companyID : company().topLevelCompanyId,
                                },
                            }"
                            anchor-route
                            data-qa="quick-links-compliance-filing-batches"
                        >
                            Filing Batches
                            @if (!isTopLevelCompany()) {
                                <span>({{ parentCompany().companyName }} and its subsidiary companies)</span>
                            }
                        </a>
                    </li>
                    <li>
                        <a
                            [sref]="{
                                target: 'electronicFiling',
                                options: {
                                    companyId: isTopLevelCompany() ? company().companyID : company().topLevelCompanyId,
                                },
                            }"
                            anchor-route
                            data-qa="quick-links-compliance-electronic-filings"
                        >
                            Electronic Filings
                            @if (!isTopLevelCompany()) {
                                <span>({{ parentCompany().companyName }} and its subsidiary companies)</span>
                            }
                        </a>
                    </li>
                </ul>
            </div>
        }

        @if (company()) {
            <div>
                <h4 class="fw-bold">Additional Information</h4>
                <ul>
                    @if (company().completedPaymentPackageCount > 0) {
                        <li>
                            <a
                                [sref]="{
                                    target: 'paymentPackagesForCompany',
                                    options: { companyID: company().companyID },
                                }"
                                anchor-route
                                data-qa="quick-links-payment-packages"
                                >Payment Packages</a
                            >
                        </li>
                    }
                    @if (shouldDisplayPaymentBatches()) {
                        <li>
                            <a (click)="goToPBCC()" class="pointer" data-qa="quick-links-payment-batches"
                                >Payment Batches</a
                            >
                        </li>
                    }
                    @if (hasInstancePrivateViewPermission()) {
                        <li>
                            <a
                                [sref]="{ target: 'forecastingBudgeting', options: { companyId: company().companyID } }"
                                anchor-route
                                data-qa="quick-links-forecasting-budgeting"
                            >
                                Forecasting
                                @if (company().budgetsEnabled) {
                                    <span>/Budgeting</span>
                                }
                            </a>
                        </li>
                    }
                    @if (accrualsEnabled && hasInstancePrivateViewPermission() && company().accrualsEnabled) {
                        <li>
                            <a
                                [sref]="{ target: 'accruals', options: { companyId: company().companyID } }"
                                anchor-route
                                data-qa="quick-links-accruals"
                                >Accruals</a
                            >
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
</div>
